import React from "react";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { PrincipalTeamItemProps } from "./PrincipalOverview.types";
import { AvatarImage } from "../../AvatarImage";
import { VeriHeading } from "../../VeriHeading";
import { ChevronRightIcon } from "../../../../icons";
import { ReadMore } from "../../ReadMore";
import { sqlDateToFullYear } from "../../../../utils/dates";
import { getPrincipalBackgroundCheckStatus } from "./helpers";

export const PrincipalTeamItem: React.FC<PrincipalTeamItemProps> = ({
  principal,
  isEditing,
  cta,
  ...rest
}) => {
  const { pendingBackgroundChecks } =
    getPrincipalBackgroundCheckStatus(principal);

  const showPendingBgChecks = isEditing && pendingBackgroundChecks;

  return (
    <Box
      {...rest}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        rest.onClick && rest.onClick(e);
      }}
    >
      <Flex alignItems="center">
        <AvatarImage image={principal.imgUrl || ""} mr={"16px"} />

        <Box>
          <VeriHeading textStyle="h6">{principal.name}</VeriHeading>
          {showPendingBgChecks && (
            <Text textStyle={"bodyRegular"}>Pending background check</Text>
          )}
          {!showPendingBgChecks && principal.title && (
            <Flex>
              <Text textStyle="bodyRegular">{principal.title}</Text>
              {principal.startDate && (
                <Text textStyle="bodyRegular" color="text.grey">
                  &nbsp;&middot; {sqlDateToFullYear(principal.startDate)} -
                  Present
                </Text>
              )}
            </Flex>
          )}
        </Box>
      </Flex>
      <Text as={Box} textStyle="bodyRegular" lineHeight="24px" mt="16px">
        <ReadMore limit={200} text={principal.descriptionHtml || ""} />
      </Text>
      {cta && (
        <Flex mt="8px">
          <Box
            cursor="pointer"
            as="span"
            fontWeight="700"
            textDecoration="underline"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              rest.onClick && rest.onClick(e);
            }}
          >
            Show Principal details
          </Box>
          <Icon ml="4px" color="black" boxSize="20px" as={ChevronRightIcon} />
        </Flex>
      )}
    </Box>
  );
};
